import React, { useState, useRef, useEffect } from "react";
import { Star, Download, Share2, Trash2, Copy, Eye, Edit } from "lucide-react";
import { motion } from "framer-motion";
import "./bookCard.styles.css";
import BookGIF from "../../../assets/images/e15925c931a81678a3c2e0c0a40db781.gif";
import { Link } from "react-router-dom";
import { Share } from "react-feather";
import BookPDFGIF from '../../../assets/images/pdf.gif';

// Material UI import
import Button from "@mui/material/Button";

// switch button import
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import { FaCode } from "react-icons/fa";
// react icons import
import {
    FaFacebook,
    FaTwitter,
    FaWhatsapp,
    FaLinkedin,
    FaTelegram,
    FaFacebookMessenger,
    FaReddit,
    FaEnvelope,
    FaGetPocket,
    FaTumblr,
    FaBlogger,
} from "react-icons/fa"


const Android12Switch = styled(Switch)(({ theme }) => ({
    padding: 8,
    "& .MuiSwitch-track": {
        borderRadius: 22 / 2,
        "&::before, &::after": {
            content: '""',
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)",
            width: 16,
            height: 16,
        },
        "&::before": {
            backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
                theme.palette.getContrastText(theme.palette.primary.main)
            )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
            left: 12,
        },
        "&::after": {
            backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
                theme.palette.getContrastText(theme.palette.primary.main)
            )}" d="M19,13H5V11H19V13Z" /></svg>')`,
            right: 12,
        },
    },
    "& .MuiSwitch-thumb": {
        boxShadow: "none",
        width: 16,
        height: 16,
        margin: 2,
    },
}));

const BookCard = ({ book, handleBookDelete, handleBookEdit, book_type, handleReadBook, handleDownloadPhotoBook, handleDownloadFlipBook, toggleEnablePreview, handleDownloadTalkingBook, handleBookEmbedModalActive }) => {

    //model states 
    const [modalActive, setModalActive] = useState(false)
    const [enablePreview, setEnablePreview] = useState(book.enable_book_preview === "1");
    const modalRef = useRef(null);


    // model for preview index page implementation
    const handleModelCloseClick = (event) => {
        if (event.target.classList.contains('history-image-model')) {
            closeModal();
        }
    };
    const closeModal = () => {
        setModalActive(false)
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                closeModal();
            }
        };

        if (modalActive) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [modalActive]);

    const handleShare = (link) => {
        if (link) {
            window.open(link, "_blank");
        }
    }
    var shareBookURL = '';
    if (book_type == 'talking_book') {
        shareBookURL = `${window.location.origin}/talking-book/${book.slug}`;

    } else if (book_type == 'flipbook') {
        shareBookURL = `${window.location.origin}/flipbook/${book.slug}`;

    } else {
        shareBookURL = `${window.location.origin}/photobook/${book.slug}`;
    }


    const socialPlatforms = [
        { name: "Facebook", icon: <FaFacebook />, color: "#1877F2", link: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareBookURL)}` },
        { name: "Twitter", icon: <FaTwitter />, color: "#1DA1F2", link: `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareBookURL)}` },
        { name: "WhatsApp", icon: <FaWhatsapp />, color: "#25D366", link: `https://api.whatsapp.com/send?text=${encodeURIComponent(shareBookURL)}` },
        { name: "LinkedIn", icon: <FaLinkedin />, color: "#0A66C2", link: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareBookURL)}` },
        { name: "Telegram", icon: <FaTelegram />, color: "#26A5E4", link: `https://t.me/share/url?url=${encodeURIComponent(shareBookURL)}` },
        { name: "Messenger", icon: <FaFacebookMessenger />, color: "#0084FF", link: `https://www.facebook.com/dialog/send?link=${encodeURIComponent(shareBookURL)}&app_id=YOUR_APP_ID&redirect_uri=${encodeURIComponent(window.location.origin)}` },
        { name: "Reddit", icon: <FaReddit />, color: "#FF4500", link: `https://www.reddit.com/submit?url=${encodeURIComponent(shareBookURL)}` },
        { name: "Gmail", icon: <FaEnvelope />, color: "#EA4335", link: `mailto:?subject=Check this out&body=${encodeURIComponent(shareBookURL)}` },
        { name: "Pocket", icon: <FaGetPocket />, color: "#EF3F56", link: `https://getpocket.com/edit?url=${encodeURIComponent(shareBookURL)}` },
        { name: "Tumblr", icon: <FaTumblr />, color: "#36465D", link: `https://www.tumblr.com/share/link?url=${encodeURIComponent(shareBookURL)}` },
        { name: "Blogger", icon: <FaBlogger />, color: "#FF8000", link: `https://www.blogger.com/blog-this.g?u=${encodeURIComponent(shareBookURL)}` },
        { name: "Outlook", icon: <FaEnvelope />, color: "#0078D4", link: `mailto:?subject=Check this out&body=${encodeURIComponent(shareBookURL)}` },
    ]

    var shareBookURL = '';
    if (book_type == 'talking_book') {
        shareBookURL = `${window.location.origin}/talking-book/${book.slug}`;
    } else if (book_type == 'flipbook') {
        shareBookURL = `${window.location.origin}/flipbook/${book.slug}`;
    } else {
        shareBookURL = `${window.location.origin}/photobook/${book.slug}`;
    }

    const handleChangeBookPreview = () => {
        setEnablePreview((prev) => !prev);
        toggleEnablePreview(book.slug, book.enable_book_preview)
    }
    return (
        <>
            {modalActive && (
                <div
                    className="history-image-model social shadow rounded position-absolute"
                    ref={modalRef}
                    onClick={handleModelCloseClick}
                >
                    <motion.div
                        className="model-body position-relative"
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 20 }}
                        transition={{ duration: 0.3 }}
                    >
                        <main className="d-flex justify-content-center align-items-center" style={{ width: "600px" }}>
                            <div className="container-fluid p-4" style={{ backgroundColor: "rgb(245, 248, 251)", maxWidth: "800px", borderRadius: "8px" }}>
                                <div className="row row-cols-1 row-cols-md-3 g-3">
                                    {socialPlatforms.map((platform) => (
                                        <div className="col" key={platform.name}>
                                            <button
                                                onClick={() => handleShare(platform.link)}
                                                className="btn d-flex align-items-center w-100 text-white"
                                                style={{
                                                    backgroundColor: platform.color,
                                                    border: "none",
                                                    padding: "8px 12px",
                                                }}
                                            >
                                                <span className="me-2" style={{ fontSize: "1.2rem" }}>
                                                    {platform.icon}
                                                </span>
                                                <span className="small fw-medium">{platform.name}</span>
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </main>
                    </motion.div>
                </div>
            )}


            <div className="bookCard bookCard-2">
                <div
                    className={`favorite-icon favorite-icon-style ${book.status == 1 ? "bg-success text-white" : "bg-secondary text-white"
                        }`}
                >
                    {book.status == 1 ? "Published" : "Draft"}
                    <p></p>
                </div>
                <div className="select-category-img">
                    <img
                        src={
                            (book_type == 'flipbook' && book.status == 1)
                                ? BookPDFGIF
                                : (book.status == 1 && book.cover_image)
                                    ? book.cover_image
                                    : BookGIF
                        }
                        alt="Book Cover"
                        className="img-fluid mx-auto d-block"
                    />
                    {Number(book.status) == 1 && (
                        <div className="preview-theme-hover" onClick={() => handleReadBook(book.slug)}>
                            <span className="theme-btn">Read</span>
                        </div>
                    )}
                </div>
                <div className="title text-dark" title={book.title}>
                    {book.title.length > 40
                        ? book.title.substring(0, 40) + "..."
                        : book.title}
                </div>

                <div className="book-actions text">
                    {Number(book.status) == 1 && (
                        <button className="action-btn" onClick={() => handleBookEmbedModalActive(book.slug)}>
                            <FaCode size={18} />
                        </button>
                    )}

                    {book_type === "photobook" && Number(book.status) == 1 && (
                        <button className="action-btn" onClick={() => handleDownloadPhotoBook(book.slug)}>
                            <Download size={18} />
                        </button>
                    )}

                    {book_type === "flipbook" && Number(book.status) == 1 && (
                        <button className="action-btn" onClick={() => handleDownloadFlipBook(book.pdf_file, book.slug)}>
                            <Download size={18} />
                        </button>
                    )}

                    {book_type === "talking_book" && Number(book.status) == 1 && (
                        <button className="action-btn" onClick={() => handleDownloadTalkingBook(book.slug)}>
                            <Download size={18} />
                        </button>
                    )}

                    <button
                        className="action-btn"
                        onClick={() => handleBookDelete(book.ids)}
                    >
                        <Trash2 size={18} />
                    </button>

                    {book_type == 'talking_book' && (
                        <button className="action-btn" onClick={() => handleBookEdit(book.slug)}>
                            <Edit size={18} />
                        </button>
                    )}
                    {Number(book.status) == 1 && (
                        <button
                            className="action-btn"
                            onClick={() => setModalActive(true)}
                        >
                            <Share2 size={18} />
                        </button>
                    )}
                </div>
                
                <div className="toggle-btn d-flex align-items-center justify-content-between">
                    <h4 className="preview-text" style={{ fontSize: "16px", fontWeight: "400", margin: "0" }}>
                        Enable Preview:
                    </h4>
                    <Android12Switch checked={enablePreview} onChange={handleChangeBookPreview} />
                </div>

                {Number(book.enable_avatar) == 1 && Number(book.avatar_approved) == 0 && (
                    <div className="marquee-container">
                        <marquee>
                            <span className="text-warning">Avatar Video is currently processing</span>
                        </marquee>
                    </div>
                )}
            </div>
        </>
    );
};

export default BookCard;
